import React from 'react';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

import './SimplePagination.scss';

interface ISimplePaginationProps {
	currentPage: number;
	setCurrentPage: any;
	hasNextPage: boolean;
}

export const SimplePagination = (props: ISimplePaginationProps): JSX.Element => {
	const { currentPage, setCurrentPage, hasNextPage } = props;

	return (
		<div className="d-flex align-items-center justify-content-end">
			<div className="pagination">
				<span
					className={clsx('page-item', currentPage > 1 ? 'cursor-pointer' : 'simple-page')}
					onClick={(): void => currentPage > 1 && setCurrentPage(currentPage - 1)}
				>
          <span className="page-link">
            {/*<i className="previous"/>*/}
	          <FontAwesomeIcon icon={faChevronLeft} className="previous" />
          </span>
				</span>
				<span
					className={clsx('page-item', hasNextPage ? 'cursor-pointer' : 'simple-page')}
					onClick={(): void => hasNextPage && setCurrentPage(currentPage + 1)}
				>
          <span className="page-link">
            {/*<i className="next"/>*/}
	          <FontAwesomeIcon icon={faChevronRight} className="next" />
          </span>
				</span>
			</div>
		</div>
	);
};
